import { inject, Injectable } from '@angular/core';
import { GoogleMapStoreModel } from 'src/app/modules/google-map/models/google-map-model';
import { IGoogleMap } from 'src/app/core/models/google-map-models';
import { AAGoogleMarkerService } from '../google/google-marker/aa-google-marker.service';
import { AALocationModel } from 'src/app/modules/route-planner/models/route-model';
import { GoogleMapEvents, AARouteEvents } from 'src/app/core/events/events';
import { GoogleMapType } from 'src/app/modules/google-map/enums/google-map-enum';
import { GoogleMapStoreService } from 'src/app/modules/google-map/services/google-map-store/google-map-store.service';
import { LocationService } from '../location-service/location.service';
import { RoutePlannerService } from 'src/app/modules/route-planner/services/route-planner/route-planner.service';
import { CoreMapLayerService } from '../core-map-layer/core-map-layer.service';
import { GoogleTagService } from '../gpt.service';

@Injectable({
  providedIn: 'root'
})
export class TrafficNewsAndMapService extends CoreMapLayerService {
  private markerIcon: any;

  public readonly LOCATION_READY: string = 'location-ready';

  public locationModel: AALocationModel;
  public googleMapModel: GoogleMapStoreModel;
  public googleMap: IGoogleMap;
  public defaultZoomLevel = 13;
  private readonly googleTagService = inject(GoogleTagService);

  constructor(public aaMarkerService: AAGoogleMarkerService,
    public googleMapStore: GoogleMapStoreService,
    public locationService: LocationService,
    public routePlannerService: RoutePlannerService) {
      super();
  }

  public attachMarker(): void {
    if (this.markerIcon) {
      this.markerIcon.setMap(null);
      this.markerIcon = null;
    }

    if (this.aaMarkerService && this.locationModel) {
      this.markerIcon = this.aaMarkerService.createMarker(this.googleMap, this.locationModel.latLng, this.locationModel.Name);
    }
  }

  public loadMapData(mapType: GoogleMapType, updateRouter?: boolean): void {
    this.loadGoogleMap(mapType);
    this.locationModel.isLoading = true;

    if (updateRouter) {
      this.updateRouterURL();
    }

    if (this.locationModel.isCurrentLocation() && this.locationService.currentLocationLoaded()) {
      this.locationService.markAsCurrentLocation(this.locationModel);
      this.onLocationReady([this.locationModel]);
      return;
    }

    if (!this.locationModel.valid()) {
      this.routePlannerService.updateLatitudeLongitude([this.locationModel])
        .subscribe(
            this.onLocationReady.bind(this),
            (error) => {
                this.locationModel.isLoading = false;
                this.locationNotFound();
            });
    } else {
      this.onLocationReady([this.locationModel]);
    }
  }

  public locationNotFound(): void { }

  public onLocationReady (locationList: Array<AALocationModel>): void {
    this.locationModel.isLoading = false;

    this.attachMarker();
    if (this.googleMapModel) {
      this.googleMapModel.mapInstance.setMapToCenter(this.googleMap, this.locationModel.latLng, this.defaultZoomLevel);
    }

    this.dispatch(this.LOCATION_READY);
    const locationName = this.locationModel.Name.split(',').at(-2);
    if (locationName) {
      this.googleTagService.updateGlobalTargeting({
        origin: locationName
          .trim()
          .replace(/[^a-zA-Z0-9]/g, '-')
          .toLowerCase()
      });
    }
  }

  public loadGoogleMap(type: GoogleMapType): IGoogleMap {
    this.googleMapModel = this.googleMapStore.getGoogleMapModel(type);
    if (this.googleMapModel) {
      this.googleMap = this.googleMapModel.googleMap;

      this.googleMapModel.mapInstance.remove(GoogleMapEvents.DRAG_END, this.mapUpdateEventListener);
      this.googleMapModel.mapInstance.remove(GoogleMapEvents.ZOOM_CHANGED, this.mapUpdateEventListener);

      this.googleMapModel.mapInstance.on(GoogleMapEvents.DRAG_END, this.mapUpdateEventListener);
      this.googleMapModel.mapInstance.on(GoogleMapEvents.ZOOM_CHANGED, this.mapUpdateEventListener);
    }
    return this.googleMap;
  }

  public updateRouterURL(): void { }
  public mapUpdateEventListener = (mapType: GoogleMapType) => { };

  public destroy(type: GoogleMapType): void {
    this.googleMapModel = this.googleMapStore.getGoogleMapModel(type);
    if (this.googleMapModel) {
      this.googleMapModel.mapInstance.remove(GoogleMapEvents.DRAG_END, this.mapUpdateEventListener);
      this.googleMapModel.mapInstance.remove(GoogleMapEvents.ZOOM_CHANGED, this.mapUpdateEventListener);
      this.googleMapModel.mapInstance.destroy();

      this.googleMapStore.destroy(type);
    }
  }
}
